import { getLocalStorageItem } from 'hooks';
import initChat from 'hooks/chatInit';
import { useAuthMe } from 'queries/AuthQueries';
import { useGetMessagesQuery } from 'queries/Message';
import { useUserUnreadMessageCount } from 'queries/Users';
import queryString from 'query-string';
import React, { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

type ContextType = {
  data: any;
  blastdata: any;
  chatClientData: any;
  member: string;
  setMember: (value: string) => void;
  updateData: (newData: any) => void;
  logout: () => void;
  isOpenGroupUiCard: boolean;
  setIsOpenGroupUiCard: (value: boolean) => void;
  isOpenUserUiCard: boolean;
  setIsOpenUserUiCard: (value: boolean) => void;
  channelList: any;
  setChannelList: any;
  runDemo: boolean;
  setRunDemo: (value: boolean) => void;
  chatUserData: any;
  setChatUserData: any;
  isDependent: boolean;
  setIsDependent: (value: boolean) => void;
  dependentData: any;
  setDependentData: (value: boolean) => void;
  dependentsList: any;
  setDependentsList: (value: boolean) => void;
  shouldSideBarOpenable: boolean;
  setShouldSideBarOpenable: (value: boolean) => void;
  refetchInboxMessageUnreadCount: () => void;
  unreadCount: number;
  allMessages: any;
  isMessageLoading: boolean;
  refetchMessages: () => void;
};

const MyContext = createContext<ContextType>({
  data: '',
  blastdata: '',
  chatClientData: null,
  member: '1',
  setMember: () => {},
  updateData: () => {},
  logout: () => {},
  isOpenGroupUiCard: false,
  setIsOpenGroupUiCard: () => {},
  isOpenUserUiCard: false,
  setIsOpenUserUiCard: () => {},
  channelList: null,
  setChannelList: () => {},
  runDemo: false,
  setRunDemo: () => {},
  chatUserData: {},
  setChatUserData: () => {},
  setIsDependent: () => {},
  isDependent: false,
  dependentData: {},
  setDependentData: () => {},
  dependentsList: [],
  setDependentsList: () => {},
  shouldSideBarOpenable: true,
  setShouldSideBarOpenable: () => {},
  refetchInboxMessageUnreadCount: () => {},
  unreadCount: 0,
  allMessages: [],
  isMessageLoading: false,
  refetchMessages: () => {},
});

const MyProvider = ({ children }: any) => {
  const [data, setData] = useState<any>([]);
  const [blastdata, setBlastdata] = useState<any>([]);
  const [chatClientData, setChatClientData] = useState(null);
  const location = useLocation();
  const urlParameters = queryString.parse(location.search);
  const [member, setMember] = useState(urlParameters?.isBlast ? '2' : '1');
  const [isOpenGroupUiCard, setIsOpenGroupUiCard] = useState(false);
  const [isOpenUserUiCard, setIsOpenUserUiCard] = useState(false);
  const [channelList, setChannelList] = useState<any>(null);
  const [runDemo, setRunDemo] = useState<boolean>(false);
  const [chatUserData, setChatUserData] = useState<object>({});
  const { data: profile, dataUpdatedAt } = useAuthMe();
  const [isDependent, setIsDependent] = useState<boolean>(false);
  const [dependentData, setDependentData] = useState<any>({});
  const [dependentsList, setDependentsList] = useState<any>([]);
  const [shouldSideBarOpenable, setShouldSideBarOpenable] =
    useState<boolean>(true);

  const { data: unReadCount, refetch: refetchInboxMessageUnreadCount } =
    useUserUnreadMessageCount();
  const [unreadCount, setUnreadCount] = useState(0);

  // console.log(chatUserData);
  useEffect(() => {
    if (profile?.data) {
      // console.log(profile?.data?.dependent);
      setDependentsList(profile?.data?.dependent);
      const channelFn = async () => {
        const { channels, blastchannels, client } = await initChat(
          profile?.data
        );
        setData(channels);
        setBlastdata(blastchannels);
        setChatClientData(client as any);
      };
      channelFn();
    }
  }, [profile, dataUpdatedAt]);

  const logout = () => {
    if (chatClientData) {
      // @ts-ignore
      chatClientData.disconnectUser();
      setData([]);
      setBlastdata([]);
      setChatClientData(null);
    }
  };

  // Fetch all Messages displayed in Inbox and Requests section
  const {
    data: allMessages,
    isLoading: isMessageLoading,
    refetch: refetchMessages,
  } = useGetMessagesQuery();

  // const refetchInboxMessageUnreadCount = () => {
  // console.log(unReadCount?.unreadCount);
  // unreadMessageCount('', {
  //   onSuccess: (res) => {
  // setUnreadCount(unReadCount?.unreadCount);
  //   },
  // });
  // };
  // console.log(unReadCount);

  useEffect(() => {
    if (unReadCount) {
      setUnreadCount(unReadCount?.unreadCount);
    }
  }, [unReadCount]); // React to unReadCount changes directly
  const updatedUserDetails = getLocalStorageItem('lang');
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(updatedUserDetails);
  }, [updatedUserDetails]);

  return (
    <MyContext.Provider
      value={{
        data,
        blastdata,
        chatClientData,
        member,
        setMember,
        updateData: setData,
        logout,
        isOpenGroupUiCard,
        setIsOpenGroupUiCard,
        isOpenUserUiCard,
        setIsOpenUserUiCard,
        channelList,
        setChannelList,
        runDemo,
        setRunDemo,
        setChatUserData,
        chatUserData,
        isDependent,
        setIsDependent,
        dependentData,
        setDependentData,
        dependentsList,
        setDependentsList,
        shouldSideBarOpenable,
        setShouldSideBarOpenable,
        refetchInboxMessageUnreadCount,
        unreadCount,
        allMessages,
        isMessageLoading,
        refetchMessages,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyProvider };
